module.exports = __webpack_public_path__ + "media/MRI8A.5bbc3128.mp3";